import { EMPTY_PORT_MODEL } from "presentation/model/Port/PortModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: PortProvider,
    useTracked: usePortTracked
} = createContainer(() => useState(EMPTY_PORT_MODEL), {concurrentMode: true});
export { PortProvider, usePortTracked };
